import { Injectable } from '@angular/core';
import { IRequestId, IRequestString } from './../domain/id.entity';
// import { KeyValueEncryptedRequest } from 'src/app/shared/domain/key-value.entity';

@Injectable()
export class RequestMakerHelpers {

  getIRequestIdEncrypted(id: number): IRequestId {
    return {
      id: id,
      encrypted: true,
    };
  }

  getIRequestStringEncrypted(value: string): IRequestString {
    return {
      value: value,
      encrypted: true,
    };
  }

  /*getIKeyValueEncryptedRequest(id: number, value: string): KeyValueEncryptedRequest {
    return {
      id: id,
      value: value,
      encrypted: true,
    };
  }*/
}
